import { data } from '../../svg/NoteStack/data';
import { makeIcon } from '../makeIcon';

export const NoteStack = makeIcon(data, 'note_stack', 'NoteStack');

export default NoteStack;
